import React, { useRef } from "react";
import IdleTimer from "react-idle-timer";
import { useDispatch } from "react-redux";
import { localStorageHelper } from "../utils";
import { logoutUser } from "../store/actions";
import { idleTime } from "../constants/componentConstants";

const IdleTimeCounter = () => {
  const idleTimeRef = useRef(null);
  const dispatch = useDispatch();

  const logoutHandler = () => {
    if (localStorageHelper.get("sessionId")) {
      dispatch(
        logoutUser({
          tenantid: localStorageHelper.get("tenantId"),
          sessionid: localStorageHelper.get("sessionId"),
          userID: localStorageHelper.get("userId"),
          tenantUrl: localStorageHelper.get("tenantUrl"),
        })
      );
    }
  };

  return (
    <>
      <IdleTimer
        ref={idleTimeRef}
        timeout={idleTime}
        onIdle={logoutHandler}
        crossTab={{
          emitOnAllTabs: true, // Emit events on all tabs/windows of a browser. Default false
        }}
      />
    </>
  );
};

export default IdleTimeCounter;
